export default __webpack_public_path__ + "static/media/franchise-expo.503c69ac.jpg";